module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"pageTitle":"Noms de domaine"},"en":{"pageTitle":"Domain names"}}')
  delete Component.options._Ctor
}
